import { render, staticRenderFns } from "./host-feedback-view.vue?vue&type=template&id=4574db07&scoped=true"
import script from "./host-feedback-view.vue?vue&type=script&lang=js"
export * from "./host-feedback-view.vue?vue&type=script&lang=js"
import style0 from "./host-feedback-view.vue?vue&type=style&index=0&id=4574db07&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4574db07",
  null
  
)

export default component.exports